import { Node_Type } from 'ricos-schema';
import BlockquoteRenderer from './blockquote/blockquote.js';
import CodeBlockRenderer from './codeblock/codeblock.js';
import HeadingRenderer from './heading/heading.js';
import BulletedListRenderer from './lists/bulletedList.js';
import ListItemRenderer from './lists/listItem.js';
import OrderedListRenderer from './lists/orderedList.js';
import ParagraphRenderer from './paragraph/paragraph.js';
import TextRenderer from './text/text.js';
import 'classnames';
import 'react';
import 'ricos-context';
import 'wix-rich-content-common';
import '../../../indentation-e83bdb4e.js';
import '../utils/Anchorable.js';
import '../utils/paywallSeo.js';
import './consts.js';
import '../../../alignment.rtlignore-5b2a79a8.js';
import '../../../lists-791021fb.js';
import 'ricos-types';
import './lists/getStartMargin.js';

const renderers = {
  [Node_Type.PARAGRAPH]: ParagraphRenderer,
  [Node_Type.TEXT]: TextRenderer,
  [Node_Type.BLOCKQUOTE]: BlockquoteRenderer,
  [Node_Type.CODE_BLOCK]: CodeBlockRenderer,
  [Node_Type.HEADING]: HeadingRenderer,
  [Node_Type.BULLETED_LIST]: BulletedListRenderer,
  [Node_Type.ORDERED_LIST]: OrderedListRenderer,
  [Node_Type.LIST_ITEM]: ListItemRenderer
};

export { renderers as default };
//# sourceMappingURL=index.js.map
